import React from 'react'
import { useLocation } from 'react-router'
import { Helmet } from 'react-helmet'
import { User } from '../../types/User'
import TeamTimeOffView from '../TeamTimeOff/TeamTimeOffView'
import PersonalTimeOff from '../PersonalTimeOff/PersonalTimeOff'

interface Props {
  profile: User
}

const Home = ({ profile }: Props) => {
  const location = useLocation()
  const isTeamTimeOffView = location.pathname === '/team-time-off'

  return (
    <>
      <Helmet title="Time Off" />
      <div
        className={`page-content${
          isTeamTimeOffView ? ' page-content--fill' : ''
        }`}
      >
        {!isTeamTimeOffView ? (
          <PersonalTimeOff profile={profile} />
        ) : (
          <TeamTimeOffView profile={profile} />
        )}
      </div>
    </>
  )
}

export default Home
